import { attach, restore } from 'effector';
import { createGate } from 'effector-react';

import { postTodoFx } from 'shared/api';
import { getModalFactory } from 'entities/modalFactory';
import { getCurrentTodosFx, TodoList } from 'features/todoList';

export const $todos = restore(getCurrentTodosFx, null);

export const { $isModalOpen, closeModal, openModal } = getModalFactory();

const postTodoEffect = attach({ effect: postTodoFx });

export const TodoModel = TodoList.factory.createModel({
  postEffect: postTodoEffect,
  onCloseTodoList: closeModal,
});

export const TodoModalGate = createGate();
